module.exports = __webpack_public_path__ + "static/media/close.459bca9c.svg";